import gql from 'graphql-tag';

export default gql`
    query GetJobLogNotes($input: GetJobLogNotesInput) {
        getJobLogNotes(input: $input) {
            id
            notes
            dateCreated
            createdBy
        }
    }
`;
